import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-solar-loan-quote-cmb.component.scss';
var FormItemSolarLoanQuoteCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemSolarLoanQuoteCmb, _super);
    function FormItemSolarLoanQuoteCmb(element) {
        return _super.call(this, element) || this;
    }
    FormItemSolarLoanQuoteCmb.prototype.init = function () {
        this.form = document.getElementById('form');
        this.submitBtn = document.getElementsByClassName('js-solar-loan-quote-cmb-submit')[0];
        this.submitApplicationBtn = document.getElementsByClassName('submit-sl-application')[0];
        this.outcomeQualified = document.getElementsByClassName('form__success--container_sl')[0];
        this.outcomeNotQualified = document.getElementsByClassName('unfavourable--container_sl')[0];
        this.outcomeError = document.getElementsByClassName('form__error--container_sl')[0];
        this.applicationSubmitted = document.getElementsByClassName('application--submitted--container_sl')[0];
        this.applicationReference = '';
        this.outcomeQualified.classList.add("hidden");
        this.outcomeNotQualified.classList.add("hidden");
        this.outcomeError.classList.add("hidden");
        this.applicationSubmitted.classList.add("hidden");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
    };
    FormItemSolarLoanQuoteCmb.prototype.bindEvents = function () {
        // fix generic close button
        var _this = this;
        var buttonContainer = document.querySelector('.apply-now__buttons');
        if (buttonContainer) {
            var closeButton = document.createElement('a');
            closeButton.href = '#';
            closeButton.className = 'button button--medium button--white button--border-blue closeBtnDone';
            closeButton.textContent = 'Close';
            buttonContainer.insertBefore(closeButton, buttonContainer.firstChild);
            this.newCloseBtn = document.querySelector('.js-apply-now-modal-close');
        }
        // this.solarForm = document.getElementById('apply-now-modal-forma32856dd48662910VgnVCM1000002c836d0aRCRD') as HTMLDivElement;
        this.headerCloseBtn = document.querySelector('.js-apply-now-modal-close');
        this.tryAgain = document.querySelector('.try-again');
        var closeBtnDoneList = document.querySelectorAll('.closeBtnDone');
        closeBtnDoneList.forEach(function (button) {
            button.addEventListener('click', function () {
                _this.resetViews();
                // this.headerCloseBtn.click();
            });
        });
        var closeBtnErrorList = document.querySelectorAll('.closeBtnError');
        closeBtnErrorList.forEach(function (button) {
            button.addEventListener('click', function () {
                _this.resetViews();
                // this.headerCloseBtn.click();
            });
        });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.submitBtn.addEventListener('click', function (event) {
            event.preventDefault();
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        this.submitApplicationBtn.addEventListener('click', function (event) {
            event.preventDefault();
            _this.submitApplicationForm();
        });
        this.newCloseBtn.addEventListener('click', function (event) {
            if (_this.headerCloseBtn) {
                _this.headerCloseBtn.click();
            }
        });
        this.headerCloseBtn.addEventListener('click', function (event) {
            _this.resetViews();
        });
        this.tryAgain.addEventListener('click', function (event) {
            event.preventDefault();
            _this.outcomeError.classList.add('hidden');
            if (_this.qualifyError == true) {
                _this.submitBtn.click();
            }
            else if (_this.submissionError == true) {
                _this.submitApplicationBtn.click();
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemSolarLoanQuoteCmb.prototype.resetViews = function () {
        this.headerCloseBtn.click();
        this.outcomeQualified.classList.add('hidden');
        this.outcomeNotQualified.classList.add('hidden');
        this.outcomeError.classList.add('hidden');
        this.applicationSubmitted.classList.add('hidden');
    };
    FormItemSolarLoanQuoteCmb.prototype.submitForm = function (form) {
        var _this = this;
        var loader = form.querySelector(".form__loader--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        var formTitle = document.querySelector("#form-item-solar-loan-quote-cmb-page .apply-now__title");
        var formData = this.getFormData();
        var url = this.baseUrl + "/leadsutils/solarquickquote";
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            }
        };
        fieldsContainer.classList.add("hidden");
        if (formTitle) {
            formTitle.classList.add("hidden");
        }
        if (loader) {
            loader.classList.add('active');
        }
        this.formsService
            .postForm(url, formData, config)
            .then(function (response) {
            var outcomeViewControl = response.data.status;
            switch (outcomeViewControl) {
                case 'success':
                    _this.showOutcome(_this.outcomeQualified);
                    _this.populateQualifiedData(response);
                    _this.applicationReference = response.data.leadId;
                    break;
                case 'successAndSubmitted':
                    _this.showOutcome(_this.applicationSubmitted);
                    break;
                case 'fail':
                    _this.showOutcome(_this.outcomeNotQualified);
                    break;
                case 'error':
                    _this.showOutcome(_this.outcomeError);
                    _this.qualifyError = true;
                    _this.submissionError = false;
                    break;
                default:
                    console.log("Unknown qualification status.");
            }
            if (loader) {
                loader.classList.remove("active");
            }
        }).catch(function (error) {
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            if (error) {
                _this.showOutcome(_this.outcomeError);
                if (loader) {
                    loader.classList.remove("active");
                }
            }
            _this.qualifyError = true;
            _this.submissionError = false;
        });
        fieldsContainer.classList.add('hidden');
    };
    FormItemSolarLoanQuoteCmb.prototype.submitApplicationForm = function () {
        var _this = this;
        var loader = document.getElementsByClassName('form__loader--container')[0];
        var params = new URLSearchParams({
            uniqueId: this.applicationReference
        }).toString();
        var url = this.baseUrl + ("/leadsutils/updatesolarquickquote?" + params);
        var config = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            }
        };
        loader.classList.remove('hidden');
        this.formsService
            .postForm(url, config)
            .then(function (response) {
            _this.outcomeQualified.classList.add("hidden");
            var outcomeViewControl = response.data;
            switch (outcomeViewControl) {
                case 'valid':
                    _this.showOutcome(_this.applicationSubmitted);
                    break;
                case 'invalid':
                    _this.showOutcome(_this.outcomeError);
                    break;
                case 'error':
                    _this.showOutcome(_this.outcomeError);
                    _this.qualifyError = false;
                    _this.submissionError = true;
                    break;
                default:
                    console.log('try again submission complete');
            }
            if (loader) {
                loader.classList.remove("active");
            }
        }).catch(function (error) {
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            if (error) {
                _this.showOutcome(_this.outcomeError);
            }
            _this.qualifyError = true;
            _this.submissionError = false;
        });
    };
    FormItemSolarLoanQuoteCmb.prototype.getDataConsentValue = function (form, selector) {
        this.form = this.element.querySelector("form");
        if (!form) {
            return null;
        }
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        return radioBtn ? radioBtn.value.toUpperCase() : null;
    };
    FormItemSolarLoanQuoteCmb.prototype.getFormData = function () {
        return {
            firstName: document.querySelector('[name="sl-first-name"]').value,
            lastName: document.querySelector('[name="sl-surname"]').value,
            sbsaCustomer: "No",
            identificationNumber: document.querySelector('[name="sl-sa-id"]').value,
            contactNumber: document.querySelector('[name="sl-contact-number"]').value,
            alternateContactNumber: document.querySelector('[name="sl-contact-number"]').value,
            emailAddress: document.querySelector('[name="sl-emailAddress"]').value,
            description: "LOOKSEE",
            grossMonthlyIncome: parseFloat(document.querySelector('[name="sl-gross"]').value),
            totalMonthlyExpenses: parseFloat(document.querySelector('[name="sl-monthlyexpenses"]').value),
            dataPrivacyConsent: document.querySelector('[name="sl-popia-consent"]')
                ? document.querySelector('[name="sl-popia-consent"]').checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataNotInsolvent: document.querySelector('[name="debt-review"]')
                ? document.querySelector('[name="debt-review"]').checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(this.form, "data-sharing-boarders"),
            cid: this.getCardinalPageID("cid")
        };
    };
    FormItemSolarLoanQuoteCmb.prototype.showOutcome = function (outcomeElement) {
        this.outcomeQualified.classList.add('hidden');
        this.outcomeNotQualified.classList.add('hidden');
        this.outcomeError.classList.add('hidden');
        this.applicationSubmitted.classList.add('hidden');
        outcomeElement.classList.remove('hidden');
    };
    FormItemSolarLoanQuoteCmb.prototype.populateQualifiedData = function (outcomeObj) {
        var FinOffMaxLimAmnt = document.getElementsByClassName('FinOffMaxLimAmnt')[0];
        var FinOffTermMaxMonths = document.getElementsByClassName('FinOffTermMaxMonths')[0];
        var FinOffRepmntAmnt = document.getElementsByClassName('FinOffRepmntAmnt')[0];
        var FinOffInstlmtMaxPer = document.getElementsByClassName('interestRate')[0];
        FinOffMaxLimAmnt.textContent = "R " + outcomeObj.data.FinOffMaxLimAmnt;
        FinOffTermMaxMonths.textContent = "X " + outcomeObj.data.FinOffTermMaxMonths + " months";
        FinOffRepmntAmnt.textContent = "R" + outcomeObj.data.FinOffRepmntAmnt + " p/m";
        FinOffInstlmtMaxPer.textContent = outcomeObj.data.FinOffInstlmtMaxPer + " %";
    };
    FormItemSolarLoanQuoteCmb.prototype.getCardinalPageID = function (name, url) {
        if (url === void 0) { url = window.location.href; }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results) {
            return "";
        }
        else if (!results[2]) {
            return "";
        }
        else {
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    };
    return FormItemSolarLoanQuoteCmb;
}(Base));
export { FormItemSolarLoanQuoteCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-solar-loan-quote-cmb/form-item-solar-loan-quote-cmb.component.ts
// module id = 968
// module chunks = 0